import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, throwError } from 'rxjs';
import { IBaseModel } from '../../models/base.model';
import { Enums } from '../../shared/enums';
import { Utils } from '../../shared/utils';
import { ErrorService } from '../../services/error.service';
import { AuthService } from '../../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (
    request: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const toastr = inject(ToastrService);
    const spinner = inject(NgxSpinnerService);
    const errorService = inject(ErrorService);
    const authService = inject(AuthService);

    return next(request).pipe(
        catchError((error): Observable<HttpEvent<any>> => {
            spinner.hide();
            spinner.hide('flowInstance');
            spinner.hide('flowObjectForm');
            spinner.hide('afterSubmit');

            // caso o erro detectado seja referente a login não realizado no Acesso Cidadão ou sua 'sessão' inválida
            if (
                error.status === HttpStatusCode.Unauthorized
                || (!error.ok && error.status === 0)
            ) {
                toastr.warning(Enums.Messages.AcessoCidadaoExpiredWarningReload, Enums.Messages.Warning, Utils.getToastrErrorOptions());
                return next(request);
            }

            let req = structuredClone(request);
            delete req?.body?.flowObjectDefinition?.publicMessageHtml;
            delete req?.body?.flowObjectDefinition?.configSchema;
            delete req?.body?.flowObjectDefinition?.formSchema;
            delete req?.body?.flowObjectDefinition?.documentHtmlContent;
            delete req?.body?.flowObjectDefinition?.next;
            delete req?.body?.flowObjectDefinition?.flowObjectDefinitionNextFlowObjectDefinitions;

            try {
                errorService.log({
                    url: error.url,
                    user: authService.$user() || null,
                    request: req || null,
                    error: error,
                });
            } catch { }

            if (error.error instanceof ErrorEvent) {
                // erro client-side ou de rede
            } else if (error.error && error.error.isSuccess != null && error.error.message != null) {
                return throwError(() => error.error as IBaseModel<any>);
            }

            toastr.error(Enums.Messages.GeneralErrorInterceptor, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return throwError(() => error);
        })
    );
};
